import { InstructionStep } from "./interfaces";

/**
 * Auxiliar function used to format the step by step instructions
 * to be sent to the backend
 * @param instructions
 */
export const formatStepByStepInstructions = (
  instructions: InstructionStep[]
) => {
  //
  const instructionsFormatted = instructions.map(
    (instruction: InstructionStep) => {
      // Define the formatted output
      const formattedOutput = { ...instruction };

      // Format the step by step image
      if (
        instruction &&
        instruction.stepImage &&
        instruction.stepImage.content
      ) {
        // Destructure to get the image without the content
        const { content, ...formattedStepImage } = instruction.stepImage;
        // Update the field without the content
        formattedOutput.stepImage = formattedStepImage;
      }

      // Format the step by step image
      if (
        instruction &&
        instruction.codeSoFarImage &&
        instruction.codeSoFarImage.content
      ) {
        // Destructure to get the image without the content
        const { content, ...formattedCodeSoFarImage } =
          instruction.codeSoFarImage;
        // Update the field without the content
        formattedOutput.codeSoFarImage = formattedCodeSoFarImage;
      }

      return formattedOutput;
    }
  );

  return instructionsFormatted;
};
